import { Component, OnInit } from '@angular/core';
import { GwrSearchModeName } from '../../gwr.constants';
import { ListLoaderPreloaded } from '../../../shared/components/list-loader/list-loader-preloaded';
import { BauprojektListEntry, BauprojektSearchResponse, GwrbauprojektService } from '../../../core/gwr-api';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { Location } from '@angular/common';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { CapAlertLevel } from '../../../core/extension/exceptions/cap-alert-level.enum';
import { GwrStatus } from '../../../shared/enum/GwrStatus';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { SearchMode } from '../../../shared/enum/searchMode';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { GwrBauprojektTableComponent } from '../gwr-bauprojekt-table/gwr-bauprojekt-table.component';

@Component({
  selector: 'cap-gwr-bauprojekt-search-result',
  templateUrl: './gwr-bauprojekt-search-result.component.html',
  styleUrls: ['./gwr-bauprojekt-search-result.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    GwrBauprojektTableComponent,
    TranslatePipe
  ]
})
export class GwrBauprojektSearchResultComponent extends AbstractComponent implements OnInit {
  searchMode: SearchMode;
  listLoader: ListLoaderPreloaded<BauprojektListEntry>;

  constructor(
    private bauprojektService: GwrbauprojektService,
    private stateService: SearchStateService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private capAlertService: CapAlertService,
    private location: Location
  ) {
    super();
    keysToTranslate<string>(['searchOhneProjektstatusZeitrahmenUndGrundstuecknummer', 'searchZeitrahmenOhneVonOderBis']);
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.searchMode = params[GwrSearchModeName];
      this.route.queryParams.subscribe((param) => {
        const requestParam = param['request'];
        if (requestParam) {
          const request = JSON.parse(requestParam);
          this.stateService.lastSearchMode = this.searchMode;
          this.loadGwrBauprojekt(request);
        }
      });
    });
  }

  private loadGwrBauprojekt(request: any) {
    this.addSub(
      this.getBauprojektListSubscription(request)[this.searchMode].subscribe(
        (response) => {
          const wsStatus = response.gwrStatusCode;
          if (wsStatus.statusCode === GwrStatus.NORESULTS) {
            this.capAlertService.info(this.translate.instant('KeineResultateGefunden'), undefined, true);
            this.navigateBackToSearch();
          } else if (wsStatus.statusCode !== GwrStatus.OK && this.searchMode !== 'fromGrundstueck') {
            const alertText = this.translate.instant('FehlerBeimAufrufDesWebservice');
            this.capAlertService.warning(`${alertText}: ${wsStatus.statusCode} (${wsStatus.text})`, CapAlertLevel.CONTENT_HEADER, true);
            this.navigateBackToSearch();
          } else {
            this.fillBauprojektListFrom(response);
          }
        },
        (err) => this.handleError(err)
      )
    );
  }

  private fillBauprojektListFrom(response: BauprojektSearchResponse) {
    this.listLoader = new ListLoaderPreloaded<BauprojektListEntry>(15, 1, response.results);
  }

  private getBauprojektListSubscription(request) {
    return {
      searchStandard: this.bauprojektService.searchBauprojektStandard(request),
      searchDossiernummer: this.bauprojektService.searchBauprojektDossiernummer(request)
    };
  }

  navigateBackToSearch() {
    this.location.back();
  }

  handleError(err) {
    throw err;
  }
}
